<H1> FASTLINK EXTENDER VIEWER <app-loader [status]="loaderStatus"></app-loader></H1>

<div *ngIf="fastLinkData?.isenabled ==0">
  <h4>Computer has no EXTENDED COMMAND set on the Fastlink Extender</h4>
</div>

<div *ngIf="fastLinkData?.isenabled ==1">
<div *ngIf="fastLinkData?.finalizedOnce ==0">
  <h4>Not finalized, the IOMapper is still busy getting all the data</h4>
</div>

<app-fast-link-lcd></app-fast-link-lcd>

<div *ngIf="fastLinkData">
  <app-fast-link-far-link [farLink]="fastLinkData.cFASTLINK_MAPPER_RUNTIME.cFASTLINK_MAP_FARLINK"></app-fast-link-far-link>
  <div *ngFor="let veldStation of fastLinkData.cFASTLINK_MAPPER_BLUEPRINT.cFASTLINK_MAPPER_VELDSTATION">
    <app-fast-link-veld-station [veldStationBluePrint]  ="veldStation"
                                [veldStationRunTime]    ="fastLinkData.cFASTLINK_MAPPER_RUNTIME.cFASTLINK_MAPPER_VELDSTATION[veldStation.station]"
                                [fastLinkListBluePrint] ="fastLinkData.cFASTLINK_MAPPER_BLUEPRINT.cFASTLINK_MAPPER_FASTLINK"
                                [fastLinkListRunTime]   ="fastLinkData.cFASTLINK_MAPPER_RUNTIME.cFASTLINK_MAPPER_FASTLINK"></app-fast-link-veld-station>
  </div>

<!--  this will show the fastlink only-->
<!--  <div *ngFor="let fastLink of fastLinkData.cFASTLINK_MAPPER_FASTLINK">-->
<!--    <app-fast-link-fast-link *ngIf="fastLink.status != 0" [fastLink]="fastLink"></app-fast-link-fast-link>-->
<!--  </div>-->

</div>
</div>
